'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Chip = require('@material-ui/core/Chip');
var styles = require('@material-ui/core/styles');
require('../ThemeProvider/ThemeProvider.js');
var colors = require('../ThemeProvider/colors.js');
require('../ThemeProvider/theme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Chip__default = /*#__PURE__*/_interopDefaultLegacy(Chip);

var _excluded = ["color"];
var PALETTE_SET = new Set(['primary', 'secondary', 'success', 'info', 'warning', 'error']);
function StatusChip(_ref) {
  var {
    color = 'grey'
  } = _ref,
      chipProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var isPaletteColor = PALETTE_SET.has(color);
  var theme = styles.useTheme();
  var backgroundColor = isPaletteColor ? styles.lighten(theme.palette[color].main, 0.5) : colors.colors[color][100];
  var textColor = isPaletteColor ? styles.darken(theme.palette[color].dark, 0.5) : styles.darken(colors.colors[color][900], 0.1);
  return /*#__PURE__*/React__namespace.createElement(Chip__default['default'], _rollupPluginBabelHelpers['extends']({}, chipProps, {
    sx: {
      fontWeight: 700,
      backgroundColor,
      color: textColor
    }
  }));
}
StatusChip.propTypes = {
  color: index.string
};

exports.StatusChip = StatusChip;
